import React from 'react'
import { Box } from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';
import { CustomTab } from 'components';

const ProductAssignmentTypeTabScreen = ({ scope }) => {
  const navigate = useNavigate();
  const routeBase = `/asignacion-productos/${scope}`;

  return (
    <Box mt={2}>
      <CustomTab
        level={1}
        panels={[
          {
            name: "TAE",
            route: `${routeBase}/tae`,
            onChange: () => navigate('tae'),
            content: <Outlet />
          },
          {
            name: "PDS",
            route: `${routeBase}/pds`,
            onChange: () => navigate('pds'),
            content: <Outlet />
          },
          {
            name: "PIN",
            route: `${routeBase}/pin`,
            onChange: () => navigate('pin'),
            content: <Outlet />
          },
        ]}
      />
    </Box>
  )
}

export default ProductAssignmentTypeTabScreen